export default "__VITE_ASSET__a9e7507a__"